import { createSelector } from 'reselect'

import { RootState } from '../../core/store/root.reducer'

export const selectAuth = (state: RootState) => state.auth

export const selectIsAuthenticated = createSelector(selectAuth, (state) => ({
  isAuthenticated: state.isAuthenticated,
  loading: state.loading,
}))
export const selectAgent = createSelector(selectAuth, (state) => ({
  agent: state.agent,
}))
